module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg01.a582b3b6.jpg";